import { ActionReducerMap } from '@ngrx/store';

import { CardState, cardReducer } from './card';
import { IdentityState, identityReducer } from './identity';
import { SummaryState, summaryReducer } from './summary';

export interface State {
  identity: IdentityState;
  summary: SummaryState;
  card: CardState;
}

export const reducers: ActionReducerMap<State> = {
  identity: identityReducer,
  summary: summaryReducer,
  card: cardReducer,
  // residence: {},
  // sourceOfFunds: {},
};
